module.exports = "https://cdn.hellotech.com/client-assets/video_doorbell_mobile_78e74e913842564d51800cb207e7f4e2.webp";